import type { FormxValueEntity } from '../entities/FormxEntity.js';
import type { IFormxRepository } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createListFormxValuesBySubmissionsUseCase({ formxRepository }: Deps) {
  return async function listFormxValuesBySubmissions(submissionIds: string[]): Promise<FormxValueEntity[]> {
    if (submissionIds.length === 0) return [];
    return formxRepository.listValuesBySubmissionIds(submissionIds);
  };
}
